import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TokenStorageService {
  private readonly tokenStorageKey = 'auth-token';

  hasToken(): boolean {
    return this.getToken() !== null;
  }

  getToken(): string|null {
    return localStorage.getItem(this.tokenStorageKey);
  }

  setToken(token: string): void {
    localStorage.setItem(this.tokenStorageKey, token);
  }

  removeToken(): void {
    localStorage.removeItem(this.tokenStorageKey);
//    localStorage.removeItem("branch_sl");
    localStorage.removeItem("user_sl");
  }
}
